import { Box, CircularProgress } from "@mui/material";
import { Component } from "react";

export class SectionLoader extends Component<any, any> {
  render() {
    const { sx } = this.props;

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "30px",
          ...sx
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
}
